<template>
  <div class="position-relative">
    <div id="avatarIcon2" class="cfa-avatar1 d-flex align-items-center">
      <img width="25" height="25" :src="image_url" alt="avatar"/>
      <div><span class="d-none d-md-flex">{{ firstname }} {{ lastname }}&nbsp;</span> &blacktriangledown; </div>
    </div>
    <div id="avatarTools" class="cfa-avatar-menu d-none">
      <!-- item1 -->
      <a href="/dashboard"><button><i class="fa fa-dashboard"></i>Tableau de bord</button></a>
      <a href="/facturation"><button class="d-flex">
        <img class="gIcon" width="20" src="../../../assets/Icons/menu_svg/Facturation.svg"
        alt="button dashbaord icon" /> <span class="ml-2" >{{ $t('sidebar.facture') }}</span> </button></a>
      <!-- item2 -->
      <a href="/parametres"><button><i class="fa fa-cogs"></i>{{ $t('param') }}</button></a>
      
      <hr>
      <button @click="logout"><i class="fa fa-sign-out"></i>{{ $t('logout') }}</button>
    </div>
  </div>
</template>

<script>
import { getAPI } from '@/axios-api.js'

export default {
  name: 'AvatartType2',
  props: {
    image: {
      type: String,
      default: 'https://picsum.photos/100'
    },
    fname: {
      type: String,
      default: '............',
      required: true,
    },
    lname: {
      type: String,
      default: '',
      required: true,
    },
    refresh: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      openMenuTools: false,
      userData: null,
      firstname: sessionStorage.firstname,
      lastname: sessionStorage.lastname,
      image_url: this.image,
    }
  },
  methods: {
    openToolsMenu () {
      let menu = document.getElementById('avatarTools')
      if(menu?.classList.contains('d-none'))
        menu.classList.remove('d-none')
      else
        menu?.classList.add('d-none')
    },
    logout () {
      this.$emit('getLogoutConfirmatiion')
    },
    retrieveUserData () {
      getAPI.get('accounts/users/me')
      .then(response => {
        if(response.status == 200) {
          this.userData = response.data.data
          sessionStorage.setItem('organisation', this.userData.organisation.id)
          //sessionStorage.setItem('organisation', this.userData.organisation)
        }
        else {
          this.displayError('Oups ! something went wrong.', 'alert-no')
        }
      })
    }
  },
  mounted () {
    this.retrieveUserData()

    document.addEventListener('click', () => {
      document.getElementById('avatarTools')?.classList.add('d-none');
    });

    document.getElementById('avatarIcon2')?.addEventListener('click', (event) => {
      this.openToolsMenu();
      event.stopPropagation();
    });
  },
  watch: {
    userData: function () {
      if(this.userData != null) {
        this.firstname = this.userData.firstname
        this.lastname = this.userData.lastname
        this.image_url = (this.userData.image_url != null) ? this.userData.image_url : this.image
        this.$emit('userData', this.userData)
      }
    },
    refresh: function () {
      this.retrieveUserData()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/app.scss";
@import "@/assets/css/style.css";
@import "@/assets/scss/index.scss";
.cfa-avatar1{
  cursor: pointer;
  /* padding: 0.5em; */
  border-radius: .5em;
  /* background-color: #f0f3f8; */
  transition: all ease-in .1s;
  margin-left: 0.5em;
}
.cfa-avatar1:hover{
  background-color: var(--primary-light-color-2);
}
.cfa-avatar1 img{
  border-radius: 100%;
  margin: 0.5em;
}
.cfa-avatar1 div{
  display: flex;
  font-weight: 400;
}

.cfa-avatar-menu hr{
  margin-top: 0.3em;
  margin-bottom: 0.3em;
}
.cfa-avatar-menu button i{
  margin-right: 0.5em;
}
.cfa-avatar-menu button:hover{
  background-color: #cef1f2;
}
.text-gray{
  color: #d1d3e2;
}
</style>
